/** 回购 */
<template>
  <div class="commit-withdrawal-wrap margin-top-20">
    <BasiceLayout
      :title="$t('pageTitle') "
      class=" revenue-all-layout  margin-top-20 commit-wrap"
    >
    <div v-if=" email == 'luoyuanqing@muhuakeji.com'" style="text-align: center;margin: 50px;">
      无权限
    </div>
    <div v-else>
        <!-- 余额  -->
        <el-row
          v-if="balance !== 'NONE'"
          class="margin-top-20"
        >
          <el-col :span="10">
            <div class="left-wrap">{{$t('balanceText')}}</div>
          </el-col>
          <el-col
            :span="14"
            class="commit-right-wrap right-wrap"
          >{{(balance || balance === 0) ? balance : '-'}} BP
          </el-col>
        </el-row>
        <el-row v-if="balance !== 'NONE'">
          <!-- 当前JD卡兑换单价 -->
          <el-col :span="10">
            <div class="left-wrap">
              <div>当前提现单价</div>
            </div>
          </el-col>
          <el-col
            :span="14"
            class="commit-right-wrap right-wrap"
          >{{RMBPrice || '-'}} 元
          </el-col>
          <!-- 可兑换JD卡总额 -->
          <el-col :span="10">
            <div class="left-wrap">
              可提现总额
            </div>
          </el-col>
          <el-col
            :span="14"
            class="commit-right-wrap right-wrap"
          >{{canExchangeMoney || '-'}} 元</el-col>
        </el-row>
        <!-- 可兑换JD卡总额 -->
        <el-row v-if="balance !== 'NONE'">
          <el-col :span="10">
            <div class="left-wrap">需要提现金额
            </div>
          </el-col>
          <el-col
            :span="14"
            class="commit-right-wrap"
          >
            <input
              type="text"
              class="input right-input "
              v-model="exchangeMoney"
            >
            <span class="bonus-tips margin-left-20">{{errorInfo}}</span>
          </el-col>
        </el-row>
        <!-- 兑换所需BP数量 -->
        <el-row v-if="balance !== 'NONE'">
          <el-col :span="10">
            <div class="left-wrap">提现所需BP数量</div>
          </el-col>
          <el-col
            :span="14"
            class="commit-right-wrap right-wrap"
          >{{ exchangeBXC || '-'}} BP
          </el-col>
        </el-row>
        <!-- 到账金额 -->
        <el-row v-if="balance !== 'NONE'">
          <el-col :span="10">
            <div class="left-wrap real-money ">
              <div>到账金额</div>
              <span class="bonus-tips">到账金额为代扣税点后金额</span>
            </div>
          </el-col>
          <el-col
            :span="14"
            class="commit-right-wrap right-wrap"
          >{{realMoney || '-'}} 元
          </el-col>
        </el-row>
        <!-- 人机验证 -->
        <el-row v-if="balance !== 'NONE'">
          <el-col :span="10">
            <div class="left-wrap">人机验证</div>
          </el-col>
          <el-col
            :span="14"
            class="commit-right-wrap"
          >
            <div style="display: flex;align-items: center;">
              <input
                type="text"
                class="input right-input"
                v-model="imageCode"
                autocomplete="off"
              >
              <img style="margin-left: 10px;" class="image" :src="imgUrl" />
              <p style="margin-left: 10px; font-size: 14px;" class="image-remark">看不清？<span style="color: #12B8B6; cursor: pointer;text-decoration: underline;" @click="queryimageCode">换一张</span></p>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="balance !== 'NONE'">
          <el-col :span="10">
            <div class="left-wrap">{{$t('withdrawal.commitWith.emailCode')}}</div>
          </el-col>
          <el-col
            :span="14"
            class="commit-right-wrap"
          >
            <SendEmailCode
              class="send-wrap right-input"
              v-model="inputEmailCode"
              :email="email"
              @emailCodeTip="emailCodeTip"
            ></SendEmailCode>
          </el-col>
        </el-row>
      <!-- 提现渠道 -->
        <el-row v-if="balance !== 'NONE'">
          <el-col :span="10">
          <div class="left-wrap">提现渠道</div>
          </el-col>
          <el-col
        :span="14"
        class="commit-right-wrap"
        >
          <el-select class="commit_channel" v-model="value" placeholder="请选择" @change="changeItem(value)">
            <el-option
            v-for="item in commitChannel"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled">
            </el-option>
          </el-select>
          </el-col>  
        </el-row>
      
      <!-- 提现渠道为支付宝时 -->
      <el-row v-if="balance !== 'NONE'">
        <el-card class="box-card" shadow="nerver" v-if="showZFB">
        <el-col class="commit-left-wrap ZFBchannel">
          <div class="ZFB_infoall">
          <span class="ZFB_info">支付宝姓名：{{ZFBName}}</span><br>
          <span class="ZFB_info" v-if="showAccount">支付宝账号：{{ZFBAccount}}</span>
          <span class="ZFB_info" v-else>支付宝账号：
            <router-link :to="{name:'MyWallet'}" class="linkto_MyWallet">请先填写收款信息</router-link>
          </span>
          </div>
        </el-col>  
      </el-card>
      </el-row>
    <!-- 提现渠道为银行卡时（暂未开通） -->
    <!-- <el-row  v-if="showBank">
        <el-col :span="10">
        <div class="left-wrap">银行卡信息</div>
        </el-col>
        <el-col
        :span="14"
        class="commit-right-wrap"
        >
        <div>姓名：银行卡</div>
        <div>账号：4234</div>
        </el-col>  
      </el-row> -->
    <!-- </div> -->
        <div
          v-if="balance !== 'NONE'"
          class="buttonWrap"
        >
          <div v-if="errorInfo" class="button-disabled button">禁 用</div>
          <div v-else @click="sureBuyBack" class="button">{{$t('confirm')}}</div>
        </div>
        <div
          v-if="balance === 'NONE'"
          class="withdrawal-upgrade"
        >{{$t('withdrawal.withUpgrade')}}</div>
      </div>
    </BasiceLayout>
  </div>
</template>

<i18n>
{
  "en": {
    "pageTitle": "提现申请",
    "balanceText": "当前BP余额",
    "lastSevenDayPrice": "当前JD卡兑换单价",
    "buyBackAccount": "输入回购数量",
    "buyBackTitle": "USDT充值码",
    "addressNotYet": "暂未生成",
    "addressCommited": "已提交，等待生成新的充值码。",
    "showAddress": "查看",
    "dialogTitle": "查看充值码",
    "commitSuccess": "提交回购成功，会在 5 个工作日直接转账至填写的支付宝账号"
  }
}
</i18n>

<script>
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import TencentVerify from "@/components/Common/TencentVerify.vue";
import SendEmailCode from "@/components/SendEmailCode.vue";
import { mapActions, mapState } from "vuex";
import { Message } from "element-ui";
import { messageTips } from "../../utils/tips.js";
import { SITEKEY } from "../../config/contant.js";
import VueRecaptcha from "vue-recaptcha";
import { log } from "util";
import { reqUrl } from '../../utils/env';
import axios from 'axios';

export default {
  name: "AccountLayout",
  props: {
    type: "",
  },
  components: {
    BasiceLayout,
    TencentVerify,
    SendEmailCode,
    VueRecaptcha,
  },
  computed: mapState({
    //  箭头函数可使代码更简练
    email: (state) => state.account.email,
    balance: (state) => state.withdrawal.balance,
    RMBPrice: (state) => state.buyBack.RMBPrice,
    discount: (state) => state.buyBack.discount,
    minAmount: (state) => state.buyBack.minAmount,
    // maxAmount: (state) => state.buyBack.maxAmount,
    maxAmount(state) {
      if (this.email === "69414265@qq.com" || this.email === "1406402743@qq.com" || this.email === "router_58@bxcmars.com" || this.email === "router_56@bxcmars.com") {
          return 300000;
      }
      // } else if (this.email === "13728916860@qq.com") {
      //     return 200000
      // }
      return state.buyBack.maxAmount;
    },
    // 可兑换JD卡总额
    canExchangeMoney() {
      if (this.balance && this.RMBPrice) {
        return parseInt(this.RMBPrice * this.balance);
      }
    },
    // 兑换BP
    exchangeBXC() {
      if (this.balance && this.RMBPrice && this.exchangeMoney) {
        return Math.ceil(this.exchangeMoney / this.RMBPrice);
      }
    },
    // 到账金额
    realMoney() {
      if (this.exchangeBXC && this.discount) {
        return Math.round(this.exchangeMoney * this.discount);
      }
    },
    errorInfo() {
      if (this.exchangeMoney) {
        if (
          this.exchangeMoney < this.minAmount ||
          this.exchangeMoney > this.maxAmount
        ) {
          return `最小提现金额为 ${this.minAmount} 元，最大提现金额为 ${this.maxAmount} 元`;
        } else if (this.exchangeMoney > this.canExchangeMoney) {
          return "余额不足";
        } else if (this.discount == 0.95 && this.exchangeMoney % 100 !== 0) {
          return "只支持以百为单位的整数提现";
        } else if (this.discount == 0.96 && this.exchangeMoney % 1000 !== 0) {
          return "只支持以千为单位的整数提现";
        } else {
          return "";
        }
      }
    },
    canCommit() {
      return (
        this.canExchangeMoney >= this.minAmount &&
        this.exchangeMoney <= this.maxAmount
      );
    },
  }),
  data() {
    return {
      ticket: "",
      csnonce: "",
      // amount: "",
      inputEmailCode: "",
      // response: "",
      sitekey: SITEKEY["LOW"],
      exchangeMoney: "",
      commitChannel:[
        {value:"支付宝",label:"支付宝"},
        {value:"银行卡",label:"银行卡（暂未开启）",disabled:true},
      ],
      value:"",
      showZFB:false,
      showAccount:true,
      ZFBName:"",
      ZFBAccount:"",
      imgUrl: '',
      imageCodeId: '',
      imageCode: ''
    };
  },
  async created() {
    this.queryimageCode();
    // 查询余额
    await this.getWithdrawalBalance();
    // 查询7天均价&usdt充值码状态
    await this.getLastSevenDayPrice({ type: this.type });
  },
  methods: {
    ...mapActions([
      "commitBuyBack",
      "getWithdrawalList",
      "getWithdrawalBalance",
      "getLastSevenDayPrice",
      "getBuybackAddress",
      "getBuyBackList",
      "getZFBInfo",
      "getCollection",
    ]),
    queryimageCode() {
      this.imageCode = '';
      try {
        axios.get(`${reqUrl}/api/getCaptcha`).then(res=>{
          this.imgUrl = res.data.data.Base64Blob;
          this.imageCodeId = res.data.data.CaptchaId;
        })
      } catch (error) {
          this.imgUrl = '';
          this.imageCodeId = '';
      }
    },
    emailCodeTip(error) {
      if (error.message) {
        Message({
          type: "error",
          message: error.message,
        });
      }
    },
    // update 验证ticket
    changeTicket(verify) {
      verify.ticket && (this.ticket = verify.ticket);
      verify.csnonce && (this.csnonce = verify.csnonce);
    },
    // 提交回购
    sureBuyBack() {
      let {
        inputEmailCode,
        canExchangeMoney,
        canCommit,
        exchangeMoney,
        ZFBAccount,
        ZFBName,
        realMoney,
        RMBPrice,
        discount,
        exchangeBXC,
		    user_name,
        imageCodeId,
        imageCode,
      } = this;

	 //判断是否填写收款信息
	 this.getCollection().then((res)=>{
		 if(!res.data.ZFBAccount || !res.data.user_name){
			 Message({
				 message:"请先填写收款信息",
				 type:"error",
			 })
			 this.$router.push({path:'/MyWallet'});
		 }else{
			 if (
			   !exchangeMoney ||
			   isNaN(exchangeMoney) ||
			   Number(exchangeMoney) > Number(canExchangeMoney)
			 ) {
			   messageTips("buyback_amount_error", this.$i18n.locale);
			 } else if(!this.imageCode) {
          return Message({
					 message:"请输入图片验证码",
					 type:"error",
				 })
       } else if(!inputEmailCode) {
			   return messageTips("limit_email_code", this.$i18n.locale);
       } else if(!this.value){
				  Message({
					 message:"请选择提现渠道",
					 type:"error",
				 })
			 } else {
			   this.$confirm(
			     `需要提现金额为 ${exchangeMoney} 元，收款到账金额为 ${realMoney}元 (支付宝账号: ${res.data.ZFBAccount}, 支付宝姓名: ${res.data.user_name})`,
			     {
			       confirmButtonText: this.$t("confirm"),
			       cancelButtonText: this.$t("cancel"),
			     }
			   ).then(() => {
			     this.commitBuyBack({
			       RMBPrice,
			       inputEmailCode,
			       canExchangeMoney,
			       canCommit,
			       exchangeMoney,
			       ZFBAccount,
			       ZFBName,
			       realMoney,
			       discount,
			       exchangeBXC,
             imageCodeId,
             imageCode,
			     }).then((res) => {
			       if (res.code === 200) {
			         // messageTips('', this.$i18n.locale);
			         Message({
			           type: "success",
			           message: this.$t("commitSuccess"),
			         });
			         this.getBuyBackList();
			       } else {
               this.queryimageCode();
			         Message({
			           type: "error",
			           message: res.message || "network error",
			         });
			       }
			     });
			   });
			 }
		 }
	 })
    },

	//提现渠道
	changeItem(value){
	  if(value = "支付宝"){
		this.getCollection().then((res)=>{
		  this.showZFB = true;
		  this.ZFBName = res.data.user_name;
		  this.ZFBAccount = res.data.ZFBAccount;
		  if(!this.ZFBAccount){
			 this.showAccount = false;
		  }else{
			 this.showAccount = true;
		  }
		})
	  }
	},
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="stylus">
.addr-status {
  margin: 40px;
  color: #909399;
}

.last-price-key {
  margin: 10px 0;
}

.commit_channel{
	margin-top:11px;
}

.commit-wrap {
  .left-wrap {
    width: 100%;
    color: #96999b;
    text-align: right;
    height: 50px;
    font-size: 14px;
    line-height: 50px;
    margin: 10px 0;
  }
  
  .ZFB_info{
	font-size:18px;
	line-height:50px;
	color:black;
	text-align:center;
  }
	
  .ZFB_infoall{
	margin-left:90px;
  }
	
  .item {
	padding: 18px 0;
  }
	
  .el-card__body{
	padding:20px 0;
  }
	
  .linkto_MyWallet{
	color:#f56c6c;
  }
	
  .box-card {
    width: 400px;
	margin:80px 37%;
	background-color:white;
	box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
	border-radius:2px;
	display:flex;
  }

  .right-wrap {
    margin: 10px 0;
    height: 50px;
    line-height: 50px;
    font-size: 24px;
  }

  .right-input {
    width: 230px;
    height: 40px;
    margin: 15px 0;
  }

  .captcha-wrap {
    margin: 15px 0;
  }

  .real-money {
    line-height: 30px;
  }
  
  .button{
  	margin-right:8%;
  }
}
</style>

